import {
  ReactIcon, NextjsIcon, VueIcon, AngularIcon, TypeScriptIcon, CloudflareIcon, RestAPIcon, PaymentGatewayIcon, MistralIcon, VSCodeIcon,
  WordpressIcon, WooCommerceIcon, MagnetoIcon, NodejsIcon, PythonIcon, SucuriIcon, OdooIcon, SAPIcon, LangGraphIcon, BluePrismIcon, JWTIcon,
  PhpIcon, LaravelIcon, DotNetIcon, AWSIcon, AzureIcon, AzureDevopsIcon, WordfenceIcon, SalesforceIcon, CrewaiIcon, GoogleIcon, StripeIcon,
  GoogleCloudIcon, KotlinIcon, DockerIcon, MySqlIcon, PostgreSqlIcon, RedisIcon, SSLIcon, MS365Icon, ScikitLearnIcon, PegaIcon, PaypalIcon,
  MongoDbIcon, FlutterIcon, SwiftIcon, NginxIcon, FigmaIcon, JenkinsIcon, WPRocketIcon, SQLServerIcon, QdrantIcon, WorkFusionIcon, RazorpayIcon,
  AdobeIcon, AtlassianIcon, JavaIcon, HTMLIcon, CodeIgniterIcon, ShopifyIcon, GitlabIcon, AppleIcon, PineconeIcon, ABBYYIcon, OpenIDIcon,
  OpenCartIcon, DrupalIcon, FirebaseIcon, UIPathIcon, PowerBIIcon, Auth0Icon, BitBucketIcon, AndroidIcon, ChromaIcon, CelonisIcon, HyvaIcon, AnsibleIcon,
  BigCommerceIcon, AlgoliaIcon,
  PowerAutomateIcon, GitIcon, JoomlaIcon, ZohoIcon, NotionIcon, SeleniumIcon, KtorIcon, GitHubIcon, OpenclawIcon, PostmanIcon, ExpressIcon, TerraformIcon,
  CypressIcon, MSOfficeIcon, OpenCVIcon, ViteIcon, ReduxIcon, MaterialIcon, SpringbootIcon, BluehostIcon, WhatsappIcon, AJAXIcon, AppcodeIcon, PodmanIcon,
  SassIcon, TailwindIcon, CSharpIcon, AntDesignIcon, CSSIcon, JavaScriptIcon, DartIcon, DigitalOceanIcon, SlackIcon, MariadbIcon, XcodeIcon, HelmIcon,
  FlaskIcon, TensorFlowIcon, ApacheIcon, djangoIcon, RailsIcon, CpanelIcon, PrometheusIcon, BootstrapIcon, MSTeamsIcon, GoogleAnalyticsIcon, MongooseIcon,
  jQueryIcon, OracleIcon, QlikIcon, GoLangIcon, FastAPIIcon, ZimbraIcon, GraphqlIcon, JestIcon, WPBakeryIcon, TelegramIcon, GoogleTagManagerIcon, RedhatIcon,
  PyTorchIcon, OpenAIIcon, KubernetesIcon, MLFlowIcon, ClaudeIcon, MulesoftIcon, OktaIcon, ElementorIcon, FacebookMessengerIcon, CocoaPodsIcon, NumpyIcon,
  PowerShellIcon, VeeamIcon, GeminiIcon, LlamaIcon, HuggingFaceIcon, LangchainIcon, APIIcon, GutenbergIcon, WeaviateIcon, FacebookIcon, NestIcon, TableauIcon,
  PostmanNewmanIcon, SwaggerOpenAPIIcon, NpmIcon, MoodleIcon, CanvasLMSIcon, GrafanaIcon, DellBoomiIcon, KongIcon, RabbitMQIcon, KeycloakIcon, SplunkIcon,
  DatadogIcon, GraylogIcon, NagiosIcon, ZabbixIcon, OpenShiftIcon, HashiCorpVaultIcon, AppiumIcon, SentryIcon, CrossplaneIcon, ArgoCDIcon, ElasticsearchIcon,
  LokiIcon, IstioIcon, TraefikIcon, KubernetesSecretsIcon, KyvernoIcon, AmazonEBSEFSIcon, PlaywriteIcon,
  MochaIcon, ChaiIcon, NgRxIcon, JasmineIcon, YarnIcon, SquareIcon, BraintreeIcon, TwilioIcon,
  InformaticaIcon, TalendIcon, DynatraceIcon, NewRelicIcon, PuppetIcon, MobXIcon, GetXIcon,
  MixpanelIcon, PulumiIcon, FluentdIcon, LinkerdIcon, FalcoIcon, SocketIOIcon, VisualStudioIcon,
  JMeterIcon, PassportJsIcon, BashIcon, SQLiteIcon, PyTestIcon, BlazorIcon, ASPNETCoreIcon,
  NetSuiteIcon, WebhooksIcon, JSONIcon, HubSpotIcon, XMLIcon, SketchIcon, PhotoshopIcon, IllustratorIcon, GooglePageSpeedInsightsIcon, LighthouseIcon, GoogleSearchConsoleIcon,
  AdobeXDIcon, InVisionIcon, BalsamiqIcon, AxureRPIcon, StorybookIcon, ZeroheightIcon, MazeIcon, UserTestingIcon, HotjarIcon,
  MicrosoftClarityIcon, ZeplinIcon, AdobeCreativeCloudIcon, WCAGIcon, WAVEIcon, AxeDevToolsIcon,
  MiroIcon, FigJamIcon, WhimsicalIcon, ProtoPieIcon, OptimalWorkshopIcon, DovetailIcon,
  WebpackIcon, GTmetrixIcon, BrowserStackIcon, PostCSSIcon, ChromeDevToolsIcon, SauceLabsIcon,
  FoundationIcon, LessIcon, WebPageTestIcon, ResponsivelyAppIcon, WebflowIcon, KlarnaIcon, AuthorizeNetIcon, TestRailIcon, 
  ZephyrIcon,
  JiraIcon,
  AzureTestPlansIcon,
  ApacheJMeterIcon,
  LoadRunnerIcon,
  GatlingIcon,
  K6Icon,
  OWASPZAPIcon,
  BurpSuiteIcon,
  NessusIcon,
  SnykIcon,
  EspressoIcon,
  XCUITestIcon,
  LambdaTestIcon,
  RESTAssuredIcon,
  SoapUIIcon,
  KarateIcon,
  SQLIcon,
  DBeaverIcon,
  ApplitoolsIcon,
  TestimIcon,
  MablIcon,
  FunctionizeIcon,
  LlamaIndexIcon, SemanticKernelIcon, RAGIcon, MilvusIcon, FAISSIcon, N8nIcon, ZapierIcon, MakeIcon,
  ApacheAirflowIcon, ApacheSparkIcon, PandasIcon, SnowflakeIcon, KubeflowIcon, WPCLIIcon,
  MFAIcon, BiometricIcon, BlockchainIcon,
  ServiceNowGRCIcon, RSAArcherIcon, OneTrustIcon, QualysIcon, TenableIcon, Rapid7Icon, PrismaCloudIcon,
  TrustArcIcon, BigIDIcon, MetricStreamIcon, LogicGateIcon, AuditBoardIcon, AccessibilityInsightsIcon,
  ChefInSpecIcon, OpenSCAPIcon, CISCATProIcon, DrataIcon, VantaIcon, SecureframeIcon,
  MCPIcon, A2AIcon, FunctionCallingIcon, AutoGenIcon, LangSmithIcon, LangfuseIcon,
  RIcon, ScalaIcon, JuliaIcon, KerasIcon, SciPyIcon, RayIcon, MediaPipeIcon, SpaCyIcon, RoboflowIcon,
  ApacheKafkaIcon, DbtIcon, BigQueryIcon, ONNXIcon, DatabricksIcon, NVIDIAIcon, WeightsBiasesIcon,
  PlotlyIcon, MatplotlibIcon, OAuthIcon, DataEncryptionIcon, RBACIcon, GDPRIcon, LookerIcon, RedshiftIcon, FivetranIcon, HadoopIcon, KafkaIcon, DAXIcon, 
  AcunetixIcon, OpenVASIcon, MetasploitIcon, SQLmapIcon, HydraIcon, NmapIcon, WiresharkIcon,
  OWASPIcon, NISTIcon, MITREATTACKIcon,
} from '@/components/home/TechIcons';

export const TECH_ICONS = {
  'React': ReactIcon, 'React.js': ReactIcon, 'React Native': ReactIcon,
  'Next.js': NextjsIcon, 'Nextjs': NextjsIcon, 'Next JS': NextjsIcon,
  'Vue': VueIcon, 'Vue.js': VueIcon,
  'Angular': AngularIcon, 'Angular Material': AngularIcon,
  'TypeScript': TypeScriptIcon,
  'WordPress': WordpressIcon, 'Wordpress': WordpressIcon, 'WordPress REST API': WordpressIcon, 'Managed WordPress Hosting': WordpressIcon, 'WordPress Security Hardening': WordpressIcon,
  'WooCommerce': WooCommerceIcon, 'WooCommerce Subscriptions': WooCommerceIcon, 'WooCommerce Memberships': WooCommerceIcon, 'WooCommerce Hooks & Filters': WooCommerceIcon, 'WooCommerce Storefront': WooCommerceIcon,
  'Magento': MagnetoIcon, 'Magneto': MagnetoIcon,
  'Node.js': NodejsIcon, 'Nodejs': NodejsIcon, 'Node JS': NodejsIcon,
  'Python': PythonIcon,
  'PHP': PhpIcon, 'PHPUnit': PhpIcon,
  'Laravel': LaravelIcon,
  '.NET': DotNetIcon, 'DotNet': DotNetIcon, 'ASP.NET': DotNetIcon, '.NET Core': ASPNETCoreIcon,
  '.NET 8': DotNetIcon, '.NET 7': DotNetIcon, '.NET 6': DotNetIcon, 'ASP.NET Core': ASPNETCoreIcon, 'ASP.NET MVC': DotNetIcon,
  'AWS': AWSIcon, 'AWS EKS': AWSIcon,
  'AWS Lambda': AWSIcon, 'Amazon EC2': AWSIcon, 'Amazon ECS': AWSIcon,
  'Amazon S3': AWSIcon, 'Amazon EBS': AWSIcon, 'Amazon EFS': AWSIcon,
  'Amazon RDS': AWSIcon, 'Amazon Aurora': AWSIcon, 'Amazon DynamoDB': AWSIcon, 'Amazon Redshift': AWSIcon,
  'Amazon VPC': AWSIcon, 'Amazon CloudFront': AWSIcon, 'Elastic Load Balancing': AWSIcon, 'Route 53': AWSIcon,
  'AWS CodePipeline': AWSIcon, 'AWS CodeBuild': AWSIcon,
  'AWS CloudTrail': AWSIcon,
  'AWS IAM': AWSIcon, 'AWS KMS': AWSIcon, 'AWS WAF': AWSIcon, 'AWS Shield': AWSIcon,
  'Amazon SageMaker': AWSIcon, 'Amazon Bedrock': AWSIcon, 'Amazon Rekognition': AWSIcon,
  'Azure': AzureIcon, 'Azure Form Recognizer': AzureIcon, 'Microsoft Azure AKS': AzureIcon,
  'Azure DevOps': AzureDevopsIcon,
  'Google Cloud': GoogleCloudIcon, 'GoogleCloud': GoogleCloudIcon, 'Google Maps': GoogleCloudIcon, 'Google Cloud GKE': GoogleCloudIcon,
  'Kotlin': KotlinIcon, 'Jetpack Compose': KotlinIcon,
  'Docker': DockerIcon,
  'MySQL': MySqlIcon,
  'PostgreSQL': PostgreSqlIcon,
  'MongoDB': MongoDbIcon,
  'Flutter': FlutterIcon, 'Flutter (for financial mobile apps)': FlutterIcon,
  'Swift': SwiftIcon, 'RxSwift': SwiftIcon,
  'NGiNX': NginxIcon, 'NGINX': NginxIcon, 'Nginx': NginxIcon,
  'Figma': FigmaIcon,
  'Jenkins': JenkinsIcon,
  'Adobe': AdobeIcon,
  'Atlassian': AtlassianIcon,
  'Java': JavaIcon,
  'HTML': HTMLIcon, 'HTML5': HTMLIcon,
  'CodeIgniter': CodeIgniterIcon,
  'Shopify': ShopifyIcon,
  'BigCommerce': BigCommerceIcon,
  'Algolia': AlgoliaIcon,
  'OpenCart': OpenCartIcon,
  'Drupal': DrupalIcon,
  'Firebase': FirebaseIcon,
  'UI Path': UIPathIcon, 'UIPath': UIPathIcon, 'UI path': UIPathIcon, 'UiPath': UIPathIcon,
  'Power BI': PowerBIIcon,
  'Power Automate': PowerAutomateIcon, 'Power-Automate': PowerAutomateIcon,
  'Git': GitIcon, 'GIT': GitIcon, 'GitHub Actions': GitIcon,
  'Joomla': JoomlaIcon,
  'Zoho': ZohoIcon,
  'Notion': NotionIcon,
  'Selenium': SeleniumIcon,
  'Cypress': CypressIcon,
  'Microsoft Office': MSOfficeIcon, 'MS Office': MSOfficeIcon,
  'OpenCV': OpenCVIcon,
  'Vite': ViteIcon,
  'Redux': ReduxIcon,
  'Material UI': MaterialIcon, 'MUI': MaterialIcon,
  'Sass': SassIcon, 'Sass/SCSS': SassIcon, 'SCSS': SassIcon,
  'Tailwind CSS': TailwindIcon, 'Tailwind': TailwindIcon,
  'C#': CSharpIcon,
  'Ant Design': AntDesignIcon,
  'CSS': CSSIcon, 'CSS3': CSSIcon,
  'JavaScript': JavaScriptIcon,
  'Flask': FlaskIcon,
  'TensorFlow': TensorFlowIcon,
  'Apache': ApacheIcon,
  'Django': djangoIcon, 'django': djangoIcon, 'Django REST Framework': djangoIcon,
  'Rails': RailsIcon, 'Ruby on Rails': RailsIcon,
  'cPanel': CpanelIcon, 'Cpanel': CpanelIcon,
  'jQuery': jQueryIcon,
  'Oracle': OracleIcon,
  'Qlik': QlikIcon,
  'Go': GoLangIcon, 'Go Lang': GoLangIcon, 'Golang': GoLangIcon,
  'FastAPI': FastAPIIcon, 'Fast API': FastAPIIcon,
  'PyTorch': PyTorchIcon, 'Py Torch': PyTorchIcon,
  'OpenAI': OpenAIIcon,
  'Kubernetes': KubernetesIcon, 'K8s': KubernetesIcon,
  'MLflow': MLFlowIcon, 'ML Flow': MLFlowIcon,
  'Claude': ClaudeIcon,
  'Zimbra': ZimbraIcon,
  'Mulesoft': MulesoftIcon, 'MuleSoft': MulesoftIcon,
  'Graphql': GraphqlIcon, 'GraphQL': GraphqlIcon,
  'Auth0': Auth0Icon,
  'Okta': OktaIcon,
  'Dart': DartIcon,
  'Prometheus': PrometheusIcon,
  'PowerShell': PowerShellIcon,
  'Veeam': VeeamIcon,
  'Azure Logic Apps': AzureIcon,
  'Azure API Management': AzureIcon,
  'Azure Service Bus': AzureIcon,
  'Azure Data Factory': AzureIcon,
  'Microsoft Azure': AzureIcon,
  'Apache Kafka': ApacheKafkaIcon,
  'Apache NiFi': ApacheIcon,
  'AWS API Gateway': AWSIcon,
  'AWS SNS/SQS': AWSIcon,
  'Springboot': SpringbootIcon, 'Spring Boot': SpringbootIcon,
  'Ktor': KtorIcon,
  'Jest': JestIcon,
  'Gemini': GeminiIcon,
  'Llama': LlamaIcon,
  'HuggingFace': HuggingFaceIcon, 'Hugging Face': HuggingFaceIcon,
  'LangChain': LangchainIcon, 'Langchain': LangchainIcon,
  'API': APIIcon, 'Third-Party APIs': APIIcon, 'Third-Party Integrations': APIIcon, 'Custom API Integrations': APIIcon,
  'Gutenberg': GutenbergIcon,
  'Elementor': ElementorIcon,
  'WP Bakery': WPBakeryIcon,
  'Bootstrap': BootstrapIcon, 'React Bootstrap': BootstrapIcon,
  'Digital Ocean': DigitalOceanIcon, 'DigitalOcean Kubernetes': DigitalOceanIcon,
  'Bluehost': BluehostIcon,
  'GitHub': GitHubIcon,
  'BitBucket': BitBucketIcon, 'Bit Bucket': BitBucketIcon, 'Bitbucket': BitBucketIcon,
  'Gitlab': GitlabIcon, 'Git Lab': GitlabIcon, 'GitLab CI/CD': GitlabIcon,
  'CI/CD': GitlabIcon, 'CI/CD Pipelines': GitlabIcon, 'CI/CD pipelines': GitlabIcon,
  'WPRocket': WPRocketIcon, 'WP Rocket': WPRocketIcon,
  'Redis': RedisIcon,
  'Cloudflare': CloudflareIcon,
  'Wordfence': WordfenceIcon,
  'Sucuri': SucuriIcon, 'SSL': SSLIcon, 'SSL Integration': SSLIcon, 'SSL Implementation': SSLIcon, 'SSL/TLS': SSLIcon, 'SSL encryption': SSLIcon,
  'Android': AndroidIcon, 'Android SDK': AndroidIcon, 'Android Studio': AndroidIcon,
  'Apple': AppleIcon, 'iOS': AppleIcon, 'Xcode IDE': AppleIcon, 'Xcode': AppleIcon, 'AppCode': AppleIcon,
  'Swift Package Manager': SwiftIcon,
  'Realm': MongoDbIcon,
  'Microsoft SQL Server': SQLServerIcon, 'SQL Server': SQLServerIcon,
  'Microsoft 365': MS365Icon, 'Microsoft Office 365': MS365Icon, 'Microsoft Dynamics 365': MS365Icon,
  'Salesforce': SalesforceIcon,
  'Odoo': OdooIcon,
  'SAP': SAPIcon,
  'Rest API': RestAPIcon, 'REST API': RestAPIcon, 'WooCommerce REST API': RestAPIcon,
  'Payment Gateway': PaymentGatewayIcon, 'Payment Gateways': PaymentGatewayIcon,
  'LangGraph': LangGraphIcon, 'Lang Graph': LangGraphIcon,
  'CrewAI': CrewaiIcon, 'Crew ai': CrewaiIcon, 'Crew AI': CrewaiIcon,
  'Scikit Learn': ScikitLearnIcon, 'Scikitlearn': ScikitLearnIcon, 'scikit-learn': ScikitLearnIcon, 'scikit': ScikitLearnIcon,
  'Qdrant': QdrantIcon,
  'Pinecone': PineconeIcon,
  'Chroma': ChromaIcon, 'ChromaDB': ChromaIcon,
  'Openclaw': OpenclawIcon, 'OpenClaw': OpenclawIcon, 'Open Claw': OpenclawIcon,
  'Whatsapp': WhatsappIcon, 'WhatsApp': WhatsappIcon,
  'Slack': SlackIcon,
  'Microsoft Teams': MSTeamsIcon, 'Teams': MSTeamsIcon,
  'Telegram': TelegramIcon,
  'Facebook Messenger': FacebookMessengerIcon,
  'Weaviate': WeaviateIcon,
  'Mistral': MistralIcon,
  'BluePrism': BluePrismIcon, 'Blue Prism': BluePrismIcon,
  'Google': GoogleIcon, 'Tesseract OCR': GoogleIcon,
  'Pega': PegaIcon, 'Pega Platform': PegaIcon,
  'WorkFusion': WorkFusionIcon, 'Work Fusion': WorkFusionIcon,
  'ABBYY': ABBYYIcon, 'ABBYY FlexiCapture': ABBYYIcon,
  'Celonis': CelonisIcon,
  'Postman': PostmanIcon,
  'AJAX': AJAXIcon,
  'Mariadb': MariadbIcon, 'Maria DB': MariadbIcon, 'MariaDB': MariadbIcon,
  'Google Analytics': GoogleAnalyticsIcon,
  'Google Tag Manager': GoogleTagManagerIcon,
  'Facebook': FacebookIcon, 'Facebook Pixel': FacebookIcon,
  'VSCode': VSCodeIcon, 'VS Code': VSCodeIcon, 'Visual Studio Code': VSCodeIcon,
  'CocoaPods': CocoaPodsIcon, 'Cocoapods': CocoaPodsIcon, 'Cocoa Pods': CocoaPodsIcon,
  'Xcode': XcodeIcon, 'X Code': XcodeIcon, 'Xcode IDE': XcodeIcon,
  'Appcode': AppcodeIcon, 'App Code': AppcodeIcon, 'AppCode': AppcodeIcon,
  '.NET MAUI': DotNetIcon,
  'ASP.NET Core': DotNetIcon,
  'Express.js': ExpressIcon, 'Express': ExpressIcon,
  'Google Cloud Platform (GCP)': GoogleCloudIcon,
  'Bitbucket Pipelines': BitBucketIcon,
  'OAuth 2.0': OAuthIcon,
  'OpePaypalIconnID Connect (OIDC)': OktaIcon,
  'Firebase Cloud Messaging (FCM)': FirebaseIcon, 'Firebase Cloud Messaging': FirebaseIcon, 'Firebase Analytics': FirebaseIcon,
  'Apple Push Notification Service (APNs)': AppleIcon, 'Apple Push Notification Service': AppleIcon, 'App Store Deployment': AppleIcon,
  'Google Play Store Deployment': AndroidIcon,
  'JWT Authentication': JWTIcon,
  'Stripe': StripeIcon,
  'Paypal': PaypalIcon, 'PayPal': PaypalIcon,
  'Razorpay': RazorpayIcon, 'RazorPay': RazorpayIcon,
  'Open ID': OpenIDIcon, 'OpenID': OpenIDIcon, 'OpenID Connect': OpenIDIcon,
  'NestJS': NestIcon, 'Nest JS': NestIcon, 'nest JS': NestIcon, 'nestJS': NestIcon,
  'Tableau': TableauIcon, 'tableau': TableauIcon,
  'Numpy': NumpyIcon, 'NumPy': NumpyIcon, 'numpy': NumpyIcon,
  'Hyva': HyvaIcon, 'hyva': HyvaIcon,
  'Mongoose': MongooseIcon,
  'POS APIs': RestAPIcon,
  'Menu Management APIs': RestAPIcon,
  'Inventory APIs': RestAPIcon,
  'Order Management APIs': RestAPIcon,
  'Kitchen Display System (KDS) APIs': RestAPIcon,
  'AWS CloudWatch': AWSIcon,
  'Apple Pay': AppleIcon,
  'Google Pay': GoogleIcon,
  'Redhat': RedhatIcon, 'Red Hat': RedhatIcon, 'Red Hat OpenShift': RedhatIcon,
  'Helm': HelmIcon,
  'Podman': PodmanIcon,
  'Terraform': TerraformIcon,
  'Ansible': AnsibleIcon,
  'Postman/Newman': PostmanNewmanIcon,
  'Swagger/OpenAPI': SwaggerOpenAPIIcon,
  'npm': NpmIcon,
  'Moodle': MoodleIcon,
  'Canvas LMS': CanvasLMSIcon,
  'Grafana': GrafanaIcon,
  'Dell Boomi': DellBoomiIcon,
  'Kong': KongIcon,
  'RabbitMQ': RabbitMQIcon,
  'Keycloak': KeycloakIcon,
  'Splunk': SplunkIcon,
  'Datadog': DatadogIcon,
  'Graylog': GraylogIcon,
  'Nagios': NagiosIcon,
  'Zabbix': ZabbixIcon,
  'OpenShift': OpenShiftIcon,
  'HashiCorp Vault': HashiCorpVaultIcon,
  'Appium': AppiumIcon,
  'Sentry': SentryIcon,
  'Crossplane': CrossplaneIcon,
  'Argo CD': ArgoCDIcon,
  'Elasticsearch': ElasticsearchIcon,
  'Loki': LokiIcon,
  'Istio': IstioIcon,
  'Traefik': TraefikIcon,
  'Kubernetes Secrets': KubernetesSecretsIcon,
  'Kyverno': KyvernoIcon,
  'Amazon EBS / EFS': AmazonEBSEFSIcon,
  'Mocha': MochaIcon,
  'Chai': ChaiIcon,
  'NgRx': NgRxIcon,
  'Jasmine': JasmineIcon,
  'Yarn': YarnIcon,
  'Square': SquareIcon,
  'Braintree': BraintreeIcon,
  'Twilio': TwilioIcon,
  'Informatica': InformaticaIcon,
  'Talend': TalendIcon,
  'Dynatrace': DynatraceIcon,
  'New Relic': NewRelicIcon,
  'Puppet': PuppetIcon,
  'MobX': MobXIcon,
  'GetX': GetXIcon,
  'Mixpanel': MixpanelIcon,
  'Pulumi': PulumiIcon,
  'Fluentd': FluentdIcon,
  'Linkerd': LinkerdIcon,
  'Falco': FalcoIcon,
  'Socket.IO': SocketIOIcon,
  'JMeter': JMeterIcon,
  'Passport.js': PassportJsIcon,
  'Bash': BashIcon,
  'WP-CLI': WPCLIIcon, 'WPCLI': WPCLIIcon,
  'Playwrite': PlaywriteIcon, 'Playwright': PlaywriteIcon,
  'SQLite': SQLiteIcon,
  'PyTest': PyTestIcon,
  'Blazor': BlazorIcon,
  'Visual Studio': VisualStudioIcon,
  'NetSuite': NetSuiteIcon,
  'Webhooks': WebhooksIcon, 'Webhook': WebhooksIcon,
  'JSON': JSONIcon,
  'HubSpot': HubSpotIcon,
  'XML': XMLIcon,
  'Apache Camel': ApacheIcon,
  'Sketch': SketchIcon,
  'Photoshop': PhotoshopIcon, 'Adobe Photoshop': PhotoshopIcon,
  'Illustrator': IllustratorIcon, 'Adobe Illustrator': IllustratorIcon,
  'Adobe XD': AdobeXDIcon,
  'InVision': InVisionIcon,
  'Balsamiq': BalsamiqIcon,
  'Axure RP': AxureRPIcon, 'Axure': AxureRPIcon,
  'Storybook': StorybookIcon,
  'Zeroheight': ZeroheightIcon,
  'Maze': MazeIcon,
  'UserTesting': UserTestingIcon,
  'Hotjar': HotjarIcon,
  'Microsoft Clarity': MicrosoftClarityIcon, 'Clarity': MicrosoftClarityIcon,
  'Zeplin': ZeplinIcon,
  'Adobe Creative Cloud': AdobeCreativeCloudIcon,
  'WCAG': WCAGIcon,
  'WAVE': WAVEIcon,
  'axe DevTools': AxeDevToolsIcon,
  'Miro': MiroIcon,
  'FigJam': FigJamIcon,
  'Whimsical': WhimsicalIcon,
  'ProtoPie': ProtoPieIcon,
  'Optimal Workshop': OptimalWorkshopIcon,
  'Dovetail': DovetailIcon,
  'Google PageSpeed Insights': GooglePageSpeedInsightsIcon,
  'Lighthouse': LighthouseIcon,
  'Google Search Console': GoogleSearchConsoleIcon,
  'Webpack': WebpackIcon,
  'GTmetrix': GTmetrixIcon,
  'BrowserStack': BrowserStackIcon,
  'GitLab': GitlabIcon,
  'Sass (SCSS)': SassIcon,
  'PostCSS': PostCSSIcon,
  'Chrome DevTools': ChromeDevToolsIcon,
  'Sauce Labs': SauceLabsIcon,
  'Foundation': FoundationIcon,
  'Less': LessIcon,
  'WebPageTest': WebPageTestIcon,
  'Responsively App': ResponsivelyAppIcon,
  'Webflow': WebflowIcon,
  'Google Lighthouse': LighthouseIcon,
  'PageSpeed Insights': GooglePageSpeedInsightsIcon,
  'CSS Grid': CSSIcon,
  'Flexbox': CSSIcon,
  'CSS Media Queries': CSSIcon,
  'Responsive Breakpoints': CSSIcon,
  'Klarna': KlarnaIcon,
  'Authorize.Net': AuthorizeNetIcon,
  'TestRail' : TestRailIcon,
  'Zephyr': ZephyrIcon,
  'Jira': JiraIcon,
  'Azure Test Plans': AzureTestPlansIcon,
  'Apache JMeter': ApacheJMeterIcon,
  'LoadRunner': LoadRunnerIcon,
  'Gatling': GatlingIcon, 
  'k6': K6Icon,
  'OWASP ZAP': OWASPZAPIcon,
  'Burp Suite': BurpSuiteIcon,
  'Nessus': NessusIcon,
  'Snyk': SnykIcon,
  'Espresso': EspressoIcon,
  'XCUITest': XCUITestIcon,
  'LambdaTest': LambdaTestIcon,
  'REST Assured': RESTAssuredIcon,
  'SoapUI': SoapUIIcon,
  'Karate': KarateIcon,
  'SQL': SQLIcon,
  'DBeaver': DBeaverIcon,
  'Applitools': ApplitoolsIcon,
  'Testim': TestimIcon,
  'Mabl': MablIcon,
  'Functionize': FunctionizeIcon,
  'Scikit-learn': ScikitLearnIcon,
  'OpenAI GPT': OpenAIIcon, 'OpenAI Embeddings': OpenAIIcon,
  'Anthropic Claude': ClaudeIcon,
  'Google Gemini': GeminiIcon,
  'Meta Llama': LlamaIcon,
  'LlamaIndex': LlamaIndexIcon,
  'Microsoft Semantic Kernel': SemanticKernelIcon, 'Semantic Kernel': SemanticKernelIcon,
  'Retrieval-Augmented Generation (RAG)': RAGIcon, 'RAG': RAGIcon,
  'Sentence Transformers': HuggingFaceIcon,
  'Milvus': MilvusIcon,
  'FAISS': FAISSIcon,
  'REST APIs': RestAPIcon,
  'AWS Bedrock': AWSIcon, 'AWS SageMaker': AWSIcon,
  'Azure AI Foundry': AzureIcon,
  'Google Vertex AI': GoogleCloudIcon,
  'n8n': N8nIcon,
  'Zapier': ZapierIcon,
  'Make': MakeIcon,
  'Microsoft Power Automate': PowerAutomateIcon,
  'Apache Airflow': ApacheAirflowIcon,
  'Apache Spark': ApacheSparkIcon,
  'Pandas': PandasIcon,
  'Snowflake': SnowflakeIcon,
  'Kubeflow': KubeflowIcon,
  'Multi-factor authentication': MFAIcon, 'Multi-Factor Authentication': MFAIcon, 'MFA': MFAIcon,
  'Biometric authentication': BiometricIcon, 'Biometric Authentication': BiometricIcon,
  'Blockchain': BlockchainIcon, 'Blockchain integration': BlockchainIcon, 'Blockchain Integration': BlockchainIcon,
  'ServiceNow GRC': ServiceNowGRCIcon,
  'RSA Archer': RSAArcherIcon,
  'OneTrust': OneTrustIcon,
  'Qualys': QualysIcon,
  'Tenable': TenableIcon,
  'Rapid7 InsightVM': Rapid7Icon,
  'AWS Security Hub': AWSIcon,
  'Microsoft Defender for Cloud': AzureIcon,
  'Prisma Cloud': PrismaCloudIcon,
  'TrustArc': TrustArcIcon,
  'BigID': BigIDIcon,
  'MetricStream': MetricStreamIcon,
  'LogicGate': LogicGateIcon,
  'AuditBoard': AuditBoardIcon,
  'Accessibility Insights': AccessibilityInsightsIcon,
  'Chef InSpec': ChefInSpecIcon,
  'OpenSCAP': OpenSCAPIcon,
  'CIS-CAT Pro': CISCATProIcon,
  'Drata': DrataIcon,
  'Vanta': VantaIcon,
  'Secureframe': SecureframeIcon,
  'Model Context Protocol (MCP)': MCPIcon, 'Model Context Protocol': MCPIcon, 'MCP': MCPIcon,
  'Agent2Agent Protocol (A2A)': A2AIcon, 'Agent2Agent Protocol': A2AIcon, 'A2A': A2AIcon,
  'Function Calling': FunctionCallingIcon, 'Tool Calling': FunctionCallingIcon,
  'AutoGen': AutoGenIcon, 'Microsoft AutoGen': AutoGenIcon,
  'LangSmith': LangSmithIcon,
  'Langfuse': LangfuseIcon,
  'OpenAI Agents SDK': OpenAIIcon,
  // Machine learning stack
  'R': RIcon,
  'Scala': ScalaIcon,
  'Julia': JuliaIcon,
  'Keras': KerasIcon,
  'SciPy': SciPyIcon,
  'Ray': RayIcon,
  'MediaPipe': MediaPipeIcon,
  'spaCy': SpaCyIcon,
  'Roboflow': RoboflowIcon,
  'Hugging Face Transformers': HuggingFaceIcon,
  'dbt': DbtIcon,
  'BigQuery': BigQueryIcon, 'Google BigQuery': BigQueryIcon,
  'ONNX': ONNXIcon,
  'Databricks': DatabricksIcon,
  'NVIDIA': NVIDIAIcon, 'NVIDIA CUDA': NVIDIAIcon,
  'Weights & Biases': WeightsBiasesIcon,
  'Azure Machine Learning': AzureIcon,
  'Plotly': PlotlyIcon,
  'Matplotlib': MatplotlibIcon,
  'OAuth': OAuthIcon,
  'Data Encryption': DataEncryptionIcon,
  'Role-Based Access Control (RBAC)': RBACIcon, 'RBAC': RBACIcon,
  'GDPR': GDPRIcon,
  'Looker' : LookerIcon,
  'Redshift' : RedshiftIcon,
  'Fivetran' : FivetranIcon,
  'Hadoop' : HadoopIcon,
  'Kafka' :KafkaIcon,
  'DAX' : DAXIcon,
  'Acunetix': AcunetixIcon,
  'OpenVAS': OpenVASIcon,
  'Metasploit': MetasploitIcon,
  'SQLmap': SQLmapIcon, 'sqlmap': SQLmapIcon,
  'Hydra': HydraIcon, 'THC Hydra': HydraIcon,
  'Nmap': NmapIcon,
  'Wireshark': WiresharkIcon,
  'OWASP': OWASPIcon,
  'NIST': NISTIcon,
  'MITRE ATT&CK': MITREATTACKIcon,
};

export function resolveTechIcon(name) {
  return TECH_ICONS[name] ?? null;
}
